// Entidade UploadedFile que se comunica com o backend PHP
import { getAuthToken } from '../auth';

// Função para obter a URL base da API
const getApiBaseUrl = () => {
  // Em desenvolvimento, use localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3007/api';
  }
  // Em produção, use o caminho relativo
  return '/api';
};

export class UploadedFile {
  static async list(sortBy = "-created_date", limit = 100) {
    try {
      console.log('Iniciando listagem de arquivos');
      
      // Fazer requisição para o endpoint PHP
      const response = await fetch(`${getApiBaseUrl()}/files.php`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`
        }
      });
      
      console.log('Resposta da API:', response.status, response.statusText);
      
      if (!response.ok) {
        console.warn('Resposta não OK ao listar arquivos:', response.status, response.statusText);
        return [];
      }
      
      const files = await response.json();
      console.log(`Recebidos ${files.length} arquivos do servidor`);
      
      // Ordenação
      let sortedFiles = [...files];
      if (sortBy.startsWith("-")) {
        const field = sortBy.substring(1);
        sortedFiles.sort((a, b) => {
          if (!a[field] || !b[field]) return 0;
          return a[field] > b[field] ? -1 : 1;
        });
      } else {
        sortedFiles.sort((a, b) => {
          if (!a[sortBy] || !b[sortBy]) return 0;
          return a[sortBy] > b[sortBy] ? 1 : -1;
        });
      }
      
      return sortedFiles.slice(0, limit);
    } catch (error) {
      console.error('Erro ao listar arquivos:', error);
      return [];
    }
  }

  static async create(fileData) {
    // Neste caso, o upload já foi feito pela função uploadFile
    // Apenas retornamos os dados recebidos
    return fileData;
  }

  static async delete(fileId) {
    try {
      console.log('Solicitando exclusão do arquivo:', fileId);
      
      // Fazer requisição para o endpoint PHP
      const response = await fetch(`${getApiBaseUrl()}/files.php/${fileId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Erro ao excluir arquivo');
      }
      
      return true;
    } catch (error) {
      console.error('Erro ao excluir arquivo:', error);
      return false;
    }
  }
}
